import { CSSProperties, forwardRef } from 'react';

import { LIST_PADDING } from 'common/constants/filterList';

// Grows the virtualized inner container by the top and bottom padding so the
// offset applied to each row (see FilterListRow) is not clipped.
//
// A stable module-level component: react-window renders `innerElementType` by
// component type, so an inline function created on every render would remount
// the whole scroll container.
export const FilterListInnerList = forwardRef<
    HTMLDivElement,
    { style: CSSProperties }
>(({ style, ...rest }, ref) => (
    <div
        ref={ref}
        style={{
            ...style,
            height: Number(style.height) + LIST_PADDING * 2,
        }}
        {...rest}
    />
));

FilterListInnerList.displayName = 'FilterListInnerList';
